import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";

import { PrimaryButton } from "../../atoms/Buttons";

const NewProgramFooterStyle = styled.footer`
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 50;
  background: #ffffff;
  box-shadow: 0px -2px 3px #00000014;
`;

export const NewProgramFooter = ({
  selectedTopic,
  changeStep,
  discard,
  lastStep,
  saveToDraft,
  submitForm,
}) => {
  return (
    <NewProgramFooterStyle className="w-full flex justify-between items-center py-4 px-8">
      <PrimaryButton
        type="button"
        bg="#CF2E3210"
        hoverBg="#CF2E3250"
        color="#CF2E32"
        onClick={discard}
      >
        Discard
      </PrimaryButton>
      <div className="flex items-center">
        {/* <PrimaryButton.Light
          type="button"
          className="flex items-center justify-between"
          onClick={saveToDraft}
          //   disabled={
          //     selectedTopic !== null && selectedTopic !== undefined ? false : true
          //   }
        >
          Save to drafts
        </PrimaryButton.Light> */}
        {lastStep ? (
          <PrimaryButton
            className="flex items-center justify-between ml-4"
            // onClick={submitForm}
            //   disabled={
            //     selectedTopic !== null && selectedTopic !== undefined ? false : true
            //   }
          >
            Publish
            <Icon.ChevronRight color="#FFFFFF" size={16} className="ml-2" />
            {/* <img
          src={
            selectedTopic !== null && selectedTopic !== undefined
              ? rightArrow
              : rightArrowGray
          }
          alt=""
        /> */}
          </PrimaryButton>
        ) : (
          <PrimaryButton
            className="flex items-center justify-between ml-4"
            onClick={changeStep}
            //   disabled={
            //     selectedTopic !== null && selectedTopic !== undefined ? false : true
            //   }
          >
            Next
            <Icon.ChevronRight color="#FFFFFF" size={16} className="ml-2" />
            {/* <img
          src={
            selectedTopic !== null && selectedTopic !== undefined
              ? rightArrow
              : rightArrowGray
          }
          alt=""
        /> */}
          </PrimaryButton>
        )}
      </div>
    </NewProgramFooterStyle>
  );
};
